/**
 * Ohne Rotkohl - Dropdown-Selektor (Material + Format)
 * ---------------------------------------------------
 * Steuert den Ersatz-Selektor aus snippets/or-dropdown-selector.liquid.
 *
 * Der native <variant-picker> des Themes bleibt im DOM und bleibt die
 * einzige Quelle der Wahrheit fuer Preis, Galerie und Kaufformular.
 * Dieses Skript setzt nur die passenden nativen Radio-Inputs und loest
 * genau ein change-Event aus, damit das Theme wie gewohnt reagiert.
 *
 * Ohne JavaScript passiert nichts: der Ersatz bleibt hidden, der native
 * Picker bleibt sichtbar und voll bedienbar.
 */
(function () {
  'use strict';

  var KEYS = { material: 'material', format: 'format' };

  function list(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function init(root) {
    if (root.dataset.orDdInit === '1') return;

    var scope = root.closest('.shopify-section') || document;
    var native =
      scope.querySelector('variant-picker[data-template-product-match="true"]') ||
      scope.querySelector('variant-picker');
    if (!native) return;

    var ui = {};
    var ok = true;
    [KEYS.material, KEYS.format].forEach(function (key) {
      ui[key] = {
        trigger: root.querySelector('[data-or-dd-trigger="' + key + '"]'),
        listEl: root.querySelector('[data-or-dd-list="' + key + '"]'),
        current: root.querySelector('[data-or-dd-current="' + key + '"]')
      };
      if (!ui[key].trigger || !ui[key].listEl || !ui[key].current) ok = false;
    });
    if (!ok) return;

    var priceEl = root.querySelector('[data-or-dd-current-price]');
    var compareEl = root.querySelector('[data-or-dd-current-compare]');

    var matOptions = list(root.querySelectorAll('[data-or-dd-material-option]'));
    var fmtOptions = list(root.querySelectorAll('[data-or-dd-format-option]'));
    if (!matOptions.length || !fmtOptions.length) return;

    // Zuordnung Option-Value-ID -> Material / Format. Die IDs der beiden
    // Optionen sind disjunkt, daher ist die Unterscheidung eindeutig.
    var materialIds = {};
    matOptions.forEach(function (el) {
      materialIds[el.dataset.orDdValueId] = el.dataset.orDdName || '';
    });
    var formatIds = {};
    fmtOptions.forEach(function (el) {
      formatIds[el.dataset.orDdValueId] = true;
    });

    var openKey = null;
    var pendingCorrection = false;
    var variantIdBefore = null;

    // Hat das Produkt weitere Optionen (z. B. Farbe)? Dann bleibt der
    // native Picker sichtbar und nur seine Zeilen fuer Format und
    // Material werden weggeclippt - der Rest gehoert weiter dem Theme.
    var passthrough = root.dataset.orDdPassthrough === '1';

    root.dataset.orDdInit = '1';
    document.documentElement.classList.add('or-dd-active');
    if (passthrough) {
      document.documentElement.classList.add('or-dd-rows');
    } else {
      native.classList.add('or-vs-native-clipped');
    }
    root.hidden = false;

    /* ---------- Lesen des nativen Pickers ---------- */

    function nativeSelection() {
      var checked = list(native.querySelectorAll('fieldset input:checked, select option[selected]'));
      var out = { materialId: null, formatId: null };
      checked.forEach(function (el) {
        var id = el.dataset ? el.dataset.optionValueId : null;
        if (!id) return;
        if (Object.prototype.hasOwnProperty.call(materialIds, id)) out.materialId = id;
        else if (formatIds[id]) out.formatId = id;
      });
      return out;
    }

    function nativeControl(valueId) {
      if (!valueId) return null;
      return native.querySelector('[data-option-value-id="' + valueId + '"]');
    }

    // Der native Picker fuehrt die gerade gewaehlte Variante als JSON mit
    // und aktualisiert sie bei jedem Re-Render. Das ist die einzige
    // verlaessliche Quelle fuer die Variant-ID - besonders bei einer
    // dritten Option, wo es je Format+Material mehrere Varianten gibt.
    function nativeVariantId() {
      var el = native.querySelector('script[type="application/json"]');
      if (!el) return null;
      try {
        var data = JSON.parse(el.textContent || 'null');
        return data && data.id ? String(data.id) : null;
      } catch (error) {
        return null;
      }
    }

    /* ---------- Zustand anzeigen ---------- */

    function formatsFor(materialId) {
      return fmtOptions.filter(function (el) {
        return el.dataset.orDdMaterialId === materialId;
      });
    }

    function setText(el, value) {
      if (el && el.textContent !== value) el.textContent = value;
    }

    function applyFilter(materialId) {
      fmtOptions.forEach(function (el) {
        el.hidden = el.dataset.orDdMaterialId !== materialId;
      });
    }

    function sync() {
      var sel = nativeSelection();
      if (!sel.materialId) return;

      applyFilter(sel.materialId);

      matOptions.forEach(function (el) {
        var on = el.dataset.orDdValueId === sel.materialId;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) setText(ui.material.current, el.dataset.orDdName || '');
      });

      var match = null;
      fmtOptions.forEach(function (el) {
        var on = el.dataset.orDdMaterialId === sel.materialId && el.dataset.orDdValueId === sel.formatId;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) match = el;
      });

      if (match) {
        setText(ui.format.current, match.dataset.orDdName || '');
        setText(priceEl, match.dataset.orDdPrice || '');
        var compare = match.dataset.orDdCompare || '';
        setText(compareEl, compare);
        if (compareEl) compareEl.hidden = compare === '';
      }

      // Der native Picker kennt beim gleichzeitigen Wechsel von Material
      // und Format die Ziel-Variante noch nicht und kann dabei einen
      // falschen ?variant= Parameter setzen. Sobald er neu gerendert hat,
      // korrigieren wir ihn aus seinem eigenen JSON.
      if (pendingCorrection) {
        var variantId = nativeVariantId();
        if (variantId && variantId !== variantIdBefore) {
          var url = new URL(window.location.href);
          if (url.searchParams.get('variant') !== variantId) {
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url.toString());
          }
          pendingCorrection = false;
          variantIdBefore = null;
        }
      }
    }

    /* ---------- Auswahl setzen ---------- */

    function commit(formatEl) {
      if (!formatEl || formatEl.dataset.orDdAvailable === 'false') return;

      var targetFormatId = formatEl.dataset.orDdValueId;
      var targetMaterialId = formatEl.dataset.orDdMaterialId;
      var before = nativeSelection();

      var formatControl = nativeControl(targetFormatId);
      var materialControl = nativeControl(targetMaterialId);
      if (!formatControl || !materialControl) return;

      var materialChanged = before.materialId !== targetMaterialId;
      var formatChanged = before.formatId !== targetFormatId;
      if (!materialChanged && !formatChanged) return;

      pendingCorrection = true;
      variantIdBefore = nativeVariantId();

      // Beide Optionen still setzen, danach genau ein change-Event feuern.
      // variant-picker.js liest ALLE gecheckten Inputs, daher kommt in einem
      // einzigen Request immer die gueltige Kombination an - nie ein
      // ungueltiger Zwischenzustand. Weitere Optionen wie Farbe fassen wir
      // dabei nicht an, ihr gecheckter Input faehrt unveraendert mit.
      [materialControl, formatControl].forEach(function (control) {
        if (control.tagName === 'INPUT') control.checked = true;
        if (control.tagName === 'OPTION') {
          var select = control.parentElement;
          list(select.options).forEach(function (o) {
            o.removeAttribute('selected');
          });
          control.setAttribute('selected', 'selected');
          select.value = control.value;
        }
      });

      // Wenn nur eine Option wechselt, feuern wir auf genau dieser - dann
      // stimmt auch der vom Theme gesetzte ?variant= Parameter sofort.
      var source = formatChanged ? formatControl : materialControl;
      var target = source.tagName === 'OPTION' ? source.parentElement : source;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));

      sync();
    }

    function chooseMaterial(materialEl) {
      if (!materialEl) return;
      var materialId = materialEl.dataset.orDdValueId;
      var candidates = formatsFor(materialId);
      if (!candidates.length) return;

      var currentName = ui.format.current.textContent.trim();

      // 1. gleiches Format im neuen Material behalten, wenn es existiert
      var keep = candidates.filter(function (el) {
        return el.dataset.orDdName === currentName && el.dataset.orDdAvailable !== 'false';
      })[0];

      // 2. sonst das erste verfuegbare Format, 3. sonst das erste ueberhaupt
      var next =
        keep ||
        candidates.filter(function (el) {
          return el.dataset.orDdAvailable !== 'false';
        })[0] ||
        candidates[0];

      applyFilter(materialId);
      commit(next);
    }

    /* ---------- Oeffnen / Schliessen ---------- */

    function itemsOf(key) {
      var all = key === KEYS.material ? matOptions : fmtOptions;
      return all.filter(function (el) {
        return !el.hidden && el.dataset.orDdAvailable !== 'false';
      });
    }

    function onDocPointer(event) {
      if (!root.contains(event.target)) close(null, false);
    }

    function open(key) {
      if (openKey === key) return;
      if (openKey) close(openKey, false);
      var entry = ui[key];
      entry.listEl.hidden = false;
      entry.trigger.setAttribute('aria-expanded', 'true');
      entry.trigger.closest('.or-vs__row').classList.add('or-vs__row--open');
      openKey = key;
      document.addEventListener('click', onDocPointer, true);

      var focusTarget =
        itemsOf(key).filter(function (el) {
          return el.getAttribute('aria-selected') === 'true';
        })[0] || itemsOf(key)[0];
      if (focusTarget) focusTarget.focus();
    }

    function close(key, focusBack) {
      var which = key || openKey;
      if (!which) return;
      var entry = ui[which];
      entry.listEl.hidden = true;
      entry.trigger.setAttribute('aria-expanded', 'false');
      entry.trigger.closest('.or-vs__row').classList.remove('or-vs__row--open');
      if (openKey === which) {
        openKey = null;
        document.removeEventListener('click', onDocPointer, true);
      }
      if (focusBack) entry.trigger.focus();
    }

    function bindTrigger(key) {
      var entry = ui[key];
      entry.trigger.addEventListener('click', function () {
        if (openKey === key) close(key, false);
        else open(key);
      });
      entry.trigger.addEventListener('keydown', function (event) {
        var k = event.key;
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ' || k === 'Spacebar') {
          event.preventDefault();
          open(key);
        } else if (k === 'Escape') {
          close(key, false);
        }
      });
      entry.listEl.addEventListener('keydown', function (event) {
        var items = itemsOf(key);
        if (!items.length) return;
        var index = items.indexOf(document.activeElement);
        var k = event.key;

        if (k === 'ArrowDown') {
          event.preventDefault();
          (items[index + 1] || items[0]).focus();
        } else if (k === 'ArrowUp') {
          event.preventDefault();
          (index > 0 ? items[index - 1] : items[items.length - 1]).focus();
        } else if (k === 'Home') {
          event.preventDefault();
          items[0].focus();
        } else if (k === 'End') {
          event.preventDefault();
          items[items.length - 1].focus();
        } else if (k === 'Enter' || k === ' ' || k === 'Spacebar') {
          event.preventDefault();
          pick(key, document.activeElement);
        } else if (k === 'Escape') {
          event.preventDefault();
          close(key, true);
        } else if (k === 'Tab') {
          close(key, false);
        }
      });
    }

    function pick(key, el) {
      if (!el) return;
      if (key === KEYS.material) chooseMaterial(el);
      else commit(el);
      close(key, true);
    }

    bindTrigger(KEYS.material);
    bindTrigger(KEYS.format);

    matOptions.forEach(function (el) {
      el.addEventListener('click', function () {
        pick(KEYS.material, el);
      });
    });
    fmtOptions.forEach(function (el) {
      el.addEventListener('click', function () {
        pick(KEYS.format, el);
      });
    });

    native.addEventListener('change', function () {
      window.setTimeout(sync, 0);
    });

    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (!passthrough && !native.classList.contains('or-vs-native-clipped')) {
          native.classList.add('or-vs-native-clipped');
        }
        sync();
      }).observe(native, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'selected', 'data-current-checked']
      });
    }

    window.addEventListener('pageshow', sync);
    sync();
  }

  // Gibt true zurueck, wenn noch ein Selektor auf seine Initialisierung
  // wartet - zum Beispiel weil der native <variant-picker> noch nicht im
  // DOM ist.
  function boot() {
    var pending = false;
    list(document.querySelectorAll('[data-or-dd]')).forEach(function (root) {
      init(root);
      if (root.dataset.orDdInit !== '1') pending = true;
    });
    return pending;
  }

  // Sicherheitsnetz: fehlt der native Picker beim ersten Versuch, versuchen
  // wir es kurz erneut. Ohne das bliebe der Selektor dauerhaft versteckt und
  // die native Button-Matrix sichtbar, falls danach kein DOM-Update folgt.
  function bootWithRetries() {
    if (!boot()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (!boot()) {
        window.clearInterval(timer);
      } else if (tries >= 20) {
        window.clearInterval(timer);
        if (window.console && window.console.warn) {
          window.console.warn(
            '[or-dropdown-selector] kein <variant-picker> gefunden - der native Picker bleibt sichtbar.'
          );
        }
      }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWithRetries);
  } else {
    bootWithRetries();
  }

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', bootWithRetries);

  // Falls das Theme den Abschnitt komplett neu rendert (z. B. beim Wechsel
  // eines verknuepften Produkts), den Selektor erneut initialisieren.
  if (window.MutationObserver && document.body) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        if (document.querySelector('[data-or-dd]:not([data-or-dd-init="1"])')) boot();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
